import { Modal, Table, Tag, Typography } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines, faUser, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
const { Text, Title } = Typography;

export default function FileDetailsModal({ isOpen, onClose, files, project, month }) {
  const filesWithUser = files.filter((f) => f.participante).length;
  const filesWithoutUser = files.length - filesWithUser;
  const getCleanFileName = (name) => name.replace(/^\d+-/, "");

  const columns = [
 {
  title: "Archivo",
  dataIndex: "name",
  key: "name",
  onCell: () => ({
    style: {
      paddingRight: 0,
      paddingLeft: 0,
    },
  }),
  render: (text, record) => {
    const cleanName = getCleanFileName(record.name);

    return (
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          maxWidth: "fit-content",   // 🔥 se achica si el texto es pequeño
        }}
      >
        <FontAwesomeIcon
          icon={faFileLines}
          style={{ color: "#888", fontSize: 14 }}
        />

        <span
          title={cleanName}
          style={{
            display: "inline-block",
            whiteSpace: "nowrap",     // ❗ evita salto de línea
            maxWidth: 350,            // 🔥 ancho máximo permitido
            overflow: "hidden",
            textOverflow: "ellipsis", // solo si supera el máximo
          }}
        >
          {cleanName}
        </span>
      </div>
    );
  },
}
,
    {
      title: "Usuario",
      key: "usuario",
      render: (_, record) =>
        record.participante ? (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <FontAwesomeIcon icon={faUser} style={{ color: "#009728", fontSize: 14 }} />
            <Text>{record.participante.nombre_participante}</Text>
          </div>
        ) : (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <FontAwesomeIcon icon={faTriangleExclamation} style={{ color: "#FAAD14", fontSize: 14 }} />
            <Text type="secondary">Sin usuario</Text>
          </div>
        ),
    },
    {
      title: "Cédula",
      key: "cedula",
      align: "center",
      render: (_, record) =>
        record.cedula ? (
          <Text code>{record.cedula}</Text>
        ) : (
          <Text type="secondary">N/A</Text>
        ),
    },
    {
      title: "Estado",
      key: "status",
       align: "center",
      render: (_, record) =>
        record.participante ? (
          <Tag color="#009728" style={{ color: "white" }}>
            Asignado
          </Tag>
        ) : (
          <Tag color="#FAAD14" style={{ color: "white" }}>
            Pendiente
          </Tag>
        ),
    },
  ];

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={1000}
    >
      <Title level={4}>
        Archivos — {project} — {month}
      </Title>
      <Text type="secondary">
        Total: {files.length} archivos | Con usuario: {filesWithUser} | Sin usuario:{" "}
        {filesWithoutUser}
      </Text>
      <div style={{ marginTop: 20 }}>
        <Table
          columns={columns}
          dataSource={files}
          rowKey={(record, index) => record.path + "-" + index}
          pagination={false}
          scroll={{ x: true }}
        />
      </div>
    </Modal>
  );
}
